import React, { useCallback, useEffect, useState } from "react";
import {
  AddButton,
  FormItemLabel,
  FormItemWrap,
  Input,
  LinkButtonWrap,
  OptionLabel,
  OptionSelect,
  OptionValue,
  Section,
  StyledButton,
  VariantType,
} from "./elements";
import { useLocation } from "react-router-dom";
import { upload, getPresignedUrl } from "../../api/s3/upload";
import { sendMail } from "../../api/sendForm";
import { PurchasedList } from "../../components/PurchasedList";
import { PurchaseData } from "../../api/mockData";

type Condition =
  | "noScratches"
  | "someScratches"
  | "noticeableScratches"
  | "crackedScreen";


const newItem: TargetItem = {
  condition: "",
  gb: "",
  name: "",
};
const getConditionText = (currentState: string | undefined) => {
  switch (currentState) {
    case "noScratches":
      return "新品同様傷なし";
    case "someScratches":
      return "若干傷あり";
    case "crackedScreen":
      return "画面割れ";
  }
};

export const PurchasedForm: React.FC = React.memo(() => {
  const { state } = useLocation();
  const [targetItemCount, setTargetItemCount] = useState(0);
  const [selectedSeries, setSelectedSeries] = useState("");
  const [selectedModel, setSelectedModel] = useState("");
  const [selectedSpec, setSelectedSpec] = useState("");
  const [selectedCondition, setSelectedCondition] = useState("");
  const initialState = {
    name: state.name,
    gb: state.gb,
    condition: getConditionText(state.condition),
  };
  const [targetItem, setTargetItem] = useState<TargetItem[]>([initialState]);
  const [fileName1, setFileName1] = useState<string>("");
  const [fileName2, setFileName2] = useState<string>("");
  const [file1, setFile1] = useState<File | null>(null);
  const [file2, setFile2] = useState<File | null>(null);
  const targetData = PurchaseData.find(
    (item) => item.id === Number(selectedSeries)
  );
  const targetSpec = targetData?.model.find(
    (item) => item.name === selectedModel
  );
  const targetCondition = targetSpec?.spec.find(
    (item) => item.id === Number(selectedSpec)
  );

  const handleAddCount = useCallback(() => {
    setTargetItem((prevTargetItem) =>
      prevTargetItem ? [...prevTargetItem, newItem] : [newItem]
    );
    setTargetItemCount(targetItemCount + 1);
  }, [setTargetItem, setTargetItemCount]);

  const handleSelectedSeries = useCallback(
    (value: string, index: number) => {
      console.log("handleSelectedSeriesINDEX", index);
      setSelectedSeries(value);
    },
    [setSelectedSeries]
  );

  const handleSelectedModel = useCallback(
    (value: string, index: number) => {
      console.log(value);
      const arrayIndex = index + 1;
      setSelectedModel(value);
      setTargetItem((prevTargetItem) => {
        if (prevTargetItem) {
          return prevTargetItem.map((item, i) => {
            if (i === arrayIndex) {
              return { ...item, name: value };
            }
            return item; // 対象でない場合は元の値をそのまま使う
          });
        }
        return prevTargetItem;
      });
    },
    [targetItem, setSelectedModel, setTargetItem]
  );

  const handleSelectedSpec = useCallback(
    (value: string, index: number) => {
      console.log(index);
      const arrayIndex = index + 1;
      setSelectedSpec(value);
      setTargetItem((prevTargetItem) => {
        if (prevTargetItem) {
          return prevTargetItem.map((item, i) => {
            if (i === arrayIndex) {
              return { ...item, gb: value };
            }
            return item; // 対象でない場合は元の値をそのまま使う
          });
        }
        return prevTargetItem;
      });
    },
    [targetItem, setSelectedSpec, setTargetItem]
  );

  const handleSelectedCondition = useCallback(
    (value: string, index: number) => {
      const arrayIndex = index + 1;
      setSelectedCondition(value);
      setTargetItem((prevTargetItem) => {
        if (prevTargetItem) {
          return prevTargetItem.map((item, i) => {
            if (i === arrayIndex) {
              return { ...item, condition: value };
            }
            return item; // 対象でない場合は元の値をそのまま使う
          });
        }
        return prevTargetItem;
      });
    },
    [targetItem, setSelectedCondition, setTargetItem]
  );
  useEffect(() => {
    initEvent();
  }, []);
  console.log(selectedSpec);
  console.log("state", state);
  /** file用inputのチェンジイベント */
  const initEvent = (): void => {
    const fileInput1 = document.getElementById("file1") as HTMLInputElement;
    const fileInput2 = document.getElementById("file2") as HTMLInputElement;

    fileInput1?.addEventListener("change", (e: Event) => {
      const target = e.target as HTMLInputElement;
      if (target.files && target.files.length > 0) {
        const selectedFile = target.files[0];
        setFileName1(selectedFile.name);
        setFile1(selectedFile);
      }
    });

    fileInput2?.addEventListener("change", (e: Event) => {
      const target = e.target as HTMLInputElement;
      if (target.files && target.files.length > 0) {
        const selectedFile = target.files[0];
        setFileName2(selectedFile.name);
        setFile2(selectedFile);
      }
    });
  };

  /** フォームパラメーター取得 */
  const getParams = (): SendMailParameter => {
    const params: SendMailParameter = {
      name: getValue("name") as string,
      email: getValue("email") as string,
      phoneNumber: getValue("phone_number") as string,
      purchaseItems: targetItem,
      remarks: getValue("remarks") as string,
      occupation: getValue("occupation") as string,
      age: getValue("age") as number,
      postCode: getValue("post_code") as string,
      address: getValue("address") as string,
      pickupDate: getValue("pickup_date") as string,
      pickupTime: getValue("pickup_time") as string,
      bankName: getValue("bank_name") as string,
      branchName: getValue("branch_name") as string,
      accountNumber: getValue("account_number") as number,
      LineAccount: getValue("line_account") as string,
      filePath: [],
    };

    return params;
  };

  /** 指定キーのvalue取得 */
  const getValue = (id: string): string | number | null => {
    const target = document.getElementById(id) as HTMLInputElement;
    return target?.value || null;
  };

  /** 送信ボタンのClickEvent用メール送信処理 */
  const send = async () => {
    const params = getParams();
    console.log(params);
    let fileSet1: FileTypeSet = {} as FileTypeSet;
    let fileSet2: FileTypeSet = {} as FileTypeSet;
    if (file1) {
      fileSet1 = { fileName: fileName1, mimeType: file1.type };
    }
    if (file2) {
      fileSet2 = { fileName: fileName2, mimeType: file2.type };
    }
    const presignedUrls = await getPresignedUrl(
      params.email,
      fileSet1,
      fileSet2
    );

    if (!presignedUrls) return;

    const uploadPromises = [];
    if (file1 && presignedUrls.url1) {
      const uploadPromise = upload(presignedUrls.url1, file1, file1.type).then(
        (filePath) => {
          return filePath || "";
        }
      );
      uploadPromises.push(uploadPromise);
    }

    if (file2 && presignedUrls.url2) {
      const uploadPromise = upload(presignedUrls.url2, file2, file2.type).then(
        (filePath) => {
          return filePath || "";
        }
      );
      uploadPromises.push(uploadPromise);
    }

    const filePaths = await Promise.all(uploadPromises);
    params.filePath.push(...filePaths.filter((path) => path));

    // メール送信
    const result = await sendMail(params);
    if (result) {
      alert("送信完了");
    }
  };

  const ageOptions = Array.from({ length: 81 }, (_, index) => ({
    value: index + 10,
    label: `${index + 10}歳`,
  }));

  const pickupTimes = [
    "8:00～13:00",
    "14:00～16:00",
    "16:00～18:00",
    "17:00～18:30",
  ];
  return (
    <Section>
      {state && (
        <>
          <FormItemWrap>
            {/* 機種 */}
            <FormItemLabel htmlFor="model">機種</FormItemLabel>
            <Input
              type="text"
              id="model"
              name="model"
              variant={VariantType.Medium}
              value={state.name}
              readOnly
            />
          </FormItemWrap>
          <FormItemWrap>
            {/* 容量 */}
            <FormItemLabel htmlFor="storage">容量</FormItemLabel>
            <Input
              type="text"
              id="storage"
              name="storage"
              variant={VariantType.Medium}
              value={state.gb}
              readOnly
            />
          </FormItemWrap>
          <FormItemWrap>
            {/* 状態 */}
            <FormItemLabel htmlFor="situation">状態</FormItemLabel>
            <Input
              type="text"
              id="situation"
              name="situation"
              variant={VariantType.Medium}
              value={getConditionText(state.condition)}
              readOnly
            />
          </FormItemWrap>
        </>
      )}
      {[...Array(targetItemCount)].map((_: number, index: number) => {
        return (
          <div>
            <FormItemWrap>
              <FormItemLabel>シリーズ</FormItemLabel>
              <OptionLabel>
                <OptionSelect
                  onChange={(e) =>
                    handleSelectedSeries(e.currentTarget.value, index)
                  }
                  defaultValue={""}
                >
                  <OptionValue hidden>選択してください</OptionValue>
                  {PurchaseData.map((item) => (
                    <OptionValue key={`model${item.series}`} value={item.id}>
                      {item.series}
                    </OptionValue>
                  ))}
                </OptionSelect>
              </OptionLabel>
            </FormItemWrap>
            {selectedSeries && (
              <FormItemWrap>
                <FormItemLabel>機種</FormItemLabel>
                <OptionLabel>
                  <OptionSelect
                    onChange={(e) =>
                      handleSelectedModel(e.currentTarget.value, index)
                    }
                  >
                    <OptionValue hidden>選択してください</OptionValue>
                    {targetData?.model.map((item) => (
                      <OptionValue key={`model${item.name}`}>
                        {item.name}
                      </OptionValue>
                    ))}
                  </OptionSelect>
                </OptionLabel>
              </FormItemWrap>
            )}
            {selectedModel && (
              <FormItemWrap>
                <FormItemLabel>容量</FormItemLabel>
                <OptionLabel>
                  <OptionSelect
                    onChange={(e) =>
                      handleSelectedSpec(e.currentTarget.value, index)
                    }
                  >
                    <OptionValue hidden>選択してください</OptionValue>
                    {targetSpec?.spec.map((item) => (
                      <OptionValue key={`model${item.gb}`}>
                        {item.gb}
                      </OptionValue>
                    ))}
                  </OptionSelect>
                </OptionLabel>
              </FormItemWrap>
            )}
            {selectedSpec && (
              <FormItemWrap>
                <FormItemLabel>状態</FormItemLabel>
                <OptionLabel>
                  <OptionSelect
                    onChange={(e) =>
                      handleSelectedCondition(e.currentTarget.value, index)
                    }
                  >
                    <OptionValue hidden>選択してください</OptionValue>
                    <OptionValue>{getConditionText("noScratches")}</OptionValue>
                    <OptionValue>
                      {getConditionText("someScratches")}
                    </OptionValue>
                    <OptionValue>
                      {getConditionText("noticeableScratches")}
                    </OptionValue>
                    <OptionValue>
                      {getConditionText("crackedScreen")}
                    </OptionValue>
                  </OptionSelect>
                </OptionLabel>
              </FormItemWrap>
            )}
          </div>
        );
      })}
      <FormItemWrap>
        <AddButton onClick={handleAddCount}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="24"
            viewBox="0 -960 960 960"
            width="24"
          >
            <path d="M450-450H200v-60h250v-250h60v250h250v60H510v250h-60v-250Z" />
          </svg>
          <span>査定する機種を追加</span>
        </AddButton>
      </FormItemWrap>
      <FormItemWrap>
        {/* 氏名 */}
        <FormItemLabel htmlFor="name">氏名</FormItemLabel>
        <Input type="text" id="name" name="name" variant={VariantType.Medium} />
      </FormItemWrap>
      <FormItemWrap>
        {/* メールアドレス */}
        <FormItemLabel htmlFor="email">メールアドレス</FormItemLabel>
        <Input
          type="email"
          id="email"
          name="email"
          variant={VariantType.Medium}
        />
      </FormItemWrap>
      <FormItemWrap>
        {/* 電話番号 */}
        <FormItemLabel htmlFor="phone_number">電話番号</FormItemLabel>
        <Input
          type="tel"
          id="phone_number"
          name="phone_number"
          variant={VariantType.Medium}
        />
      </FormItemWrap>
      <FormItemWrap>
        {/* 職業 */}
        <FormItemLabel htmlFor="occupation">職業</FormItemLabel>
        <OptionLabel>
          <OptionSelect id="occupation" name="occupation">
            <OptionValue value="会社員">会社員</OptionValue>
            <OptionValue value="公務員">公務員</OptionValue>
            <OptionValue value="自営業/個人事業">自営業/個人事業</OptionValue>
            <OptionValue value="会社役員">会社員</OptionValue>
            <OptionValue value="自由業">自由業</OptionValue>
            <OptionValue value="専業主婦・主夫">専業主婦・主夫</OptionValue>
            <OptionValue value="学生">学生</OptionValue>
            <OptionValue value="アルバイト/パート">
              アルバイト/パート
            </OptionValue>
            <OptionValue value="無職">無職</OptionValue>
            <OptionValue value="その他">その他</OptionValue>
          </OptionSelect>
        </OptionLabel>
      </FormItemWrap>
      <FormItemWrap>
        {/* 年齢 */}
        <FormItemLabel htmlFor="age">年齢</FormItemLabel>
        <OptionLabel>
          <OptionSelect id="age" name="age">
            {ageOptions.map((option) => (
              <OptionValue
                key={option.value}
                value={option.value}
                defaultValue={20}
              >
                {option.label}
              </OptionValue>
            ))}
          </OptionSelect>
        </OptionLabel>
      </FormItemWrap>
      <FormItemWrap>
        {/* 郵便番号 */}
        <FormItemLabel htmlFor="post_code">
          郵便番号(ハイフンなし)
        </FormItemLabel>
        <Input
          type="text"
          id="post_code"
          name="post_code"
          variant={VariantType.Medium}
        />
      </FormItemWrap>
      <FormItemWrap>
        {/* 住所 */}
        <FormItemLabel htmlFor="address">住所</FormItemLabel>
        <Input
          type="text"
          id="address"
          name="address"
          variant={VariantType.Medium}
        />
      </FormItemWrap>
      <FormItemWrap>
        {/* 集荷希望日 */}
        <FormItemLabel htmlFor="pickup_date">集荷希望日</FormItemLabel>
        <Input
          type="date"
          id="pickup_date"
          name="pickup_date"
          variant={VariantType.Medium}
        />
      </FormItemWrap>
      <FormItemWrap>
        {/* 集荷希望時間帯 */}
        <FormItemLabel htmlFor="pickup_time">集荷希望時間帯</FormItemLabel>
        <OptionLabel>
          <OptionSelect id="pickup_time" name="pickup_time">
            {pickupTimes.map((option) => (
              <OptionValue key={option} value={option}>
                {option}
              </OptionValue>
            ))}
          </OptionSelect>
        </OptionLabel>
      </FormItemWrap>
      <FormItemWrap>
        {/* 銀行名 */}
        <FormItemLabel htmlFor="bank_name">銀行名</FormItemLabel>
        <Input
          type="text"
          id="bank_name"
          name="bank_name"
          variant={VariantType.Medium}
        />
      </FormItemWrap>
      <FormItemWrap>
        {/* 支店名 */}
        <FormItemLabel htmlFor="branch_name">支店名</FormItemLabel>
        <Input
          type="text"
          id="branch_name"
          name="branch_name"
          variant={VariantType.Medium}
        />
      </FormItemWrap>
      <FormItemWrap>
        {/* 口座番号 */}
        <FormItemLabel htmlFor="account_number">口座番号</FormItemLabel>
        <Input
          type="number"
          id="account_number"
          name="account_number"
          variant={VariantType.Medium}
        />
      </FormItemWrap>
      <FormItemWrap>
        {/* Lineアカウント名 */}
        <FormItemLabel htmlFor="line_account">Lineアカウント名</FormItemLabel>
        <Input
          type="text"
          id="line_account"
          name="line_account"
          variant={VariantType.Medium}
        />
      </FormItemWrap>
      <FormItemWrap>
        {/* 身分証1 */}
        <FormItemLabel htmlFor="file1">身分証1</FormItemLabel>
        <Input
          type="file"
          id="file1"
          name="file1"
          variant={VariantType.Medium}
        />
      </FormItemWrap>
      <FormItemWrap>
        {/* 身分証2 */}
        <FormItemLabel htmlFor="file2">身分証2</FormItemLabel>
        <Input
          type="file"
          id="file2"
          name="file2"
          variant={VariantType.Medium}
        />
      </FormItemWrap>
      <FormItemWrap>
        {/* 備考 */}
        <FormItemLabel htmlFor="remarks">備考</FormItemLabel>
        <Input
          type="text"
          id="remarks"
          name="remarks"
          variant={VariantType.Medium}
        />
      </FormItemWrap>
      <LinkButtonWrap>
        <StyledButton type="button" id="send" onClick={send}>
          送信
        </StyledButton>
      </LinkButtonWrap>
    </Section>
  );
});

PurchasedForm.displayName = "PurchasedForm";
